module.exports = __webpack_public_path__ + "static/media/1019817.6b46ffd2.jpg";